/**
 * @fileoverview 生成加密对象
 * @author chengshuangfeng | chengshuangfeng@zuoyebang.com
 * @version 1.0 | 2018-09-04 | chengshuangfeng    // 初始版本。
 * @param {object} 参数没有顺序，但是值必须得是字符串
 * @return {object} 对象 {ftime:ftime,fkey:fkey}
 *
 * //获取时间戳加1-100的随机数
 *
 * var timestamp = parseInt(new Date().getTime() / 1000);
    var rn = parseInt(Math.random() * 100);
    var ftime = timestamp + rn;
    //把时间转成字符串放到参数数组里，对键key进行升序排序，
    args[0].ftime  = JSON.stringify(ftime);
    var array = Object.keys(args[0]);
    array.sort(function(a,b){
        if(a > b) return 1;
        if(a < b) return -1;
        return 0;
    })
    //根据排好的键，把其值进行连接
    var key = "";
    array.forEach(function(value,index){
        key = key + args[0][value]
    })
    //加秘钥
    key += 'CA#7H!F9^10';
    //进行加密转化
    var fkey = hex_md5(key);
    //此代码是机密，在加密处进行两次加密，发布的时候会自动把注释去掉
 */

/**
 *
 *
 * 实例：
 *
 * 1. 首先在tpl中引用md5.js {%require name="kd-activity:static/ballGame/md5.js"%}
 * 2. 在js中引用模块   var Generate = require('kd-activity:widget/generate/generate.js');
 * 3. var generate = new Generate({"abc":"123","hello":"true","haha":"nihao"});
 *    //参数没有顺序，但是值必须得是字符串，对象可以为空，默认是空对象
 *
 */
import MD5 from 'md5.js';

class GenerateCls {
  constructor(config) {
    this.ftime = null;
    this.fkey = null;
    this._init(config || {});
  }

  _init(...args) {
    const timestamp = args.timestamp || parseInt(new Date().getTime() / 1000);
    const rn = parseInt(Math.random() * 100);
    const ftime = timestamp + rn;
    // 把时间转成字符串放到参数数组里，对键key进行升序排序，
    args[0].ftime = JSON.stringify(ftime);
    const array = Object.keys(args[0]);
    array.sort(function (a, b) {
      if (a > b) {
        return 1;
      }
      if (a < b) {
        return -1;
      }
      return 0;
    });
    // 根据排好的键，把其值进行连接
    let key = '';
    array.forEach(function (value) {
      key = key + args[0][value];
    });
    // 加秘钥
    key += 'CA#7H!F9^10';

    // 进行加密转
    this.ftime = ftime;
    const key1 = new MD5().update(key).digest('hex');
    this.fkey = key1;
  }
}
export default GenerateCls;
